import React from "react";
import { withStyles } from "@material-ui/core";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from "prop-types";
import Grid from '@material-ui/core/Grid';

const styles = theme => ({
});


class DetailDialog extends React.Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
    }

    render() {
        return (
            <Dialog
                open={this.props.open}
                keepMounted
                onClose={this.props.onCancel}
            >

                <DialogTitle>{this.props.dialogTitle}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        <div style={{ maxWidth: '100%' }}>

                            <Grid container spacing={3}>

                                {this.props.data && this.props.data.map(d =>

                                    <React.Fragment>
                                        <Grid item xs={12} lg={6}>
                                            <b>{d.label}</b>
                                        </Grid>
                                        <Grid item xs={12} lg={6}>
                                            {d.value}
                                        </Grid>
                                    </React.Fragment>
                                )}

                            </Grid>

                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onCancel} color="primary">
                        {this.props.cancelText}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

DetailDialog.propTypes = {
    classes: PropTypes.object.isRequired,
};



export default withStyles(styles, { withTheme: true })(DetailDialog)
